import React, { Component, useState } from 'react'
import './Details.css'
import Navbar, { Navbarsalaamstree } from '../Navbar/Navbar'
import cover from '../../images/salaamstreecover.png'
import chetna from '../../images/chetna.png'

import Footer from '../Footer/Footer'
import Salaamstree from '../Salaamstree/Salaamstree'
import { maxwidth ,pink,green,footer_gray} from '../../constants'
import { Divider } from '@mui/material'
import { useEffect } from "react";
import { useLocation } from "react-router-dom";



export default function Details(){

    

    useEffect(() => {
      window.scrollTo(0, 0);
    });

  const location=useLocation();


    return (
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }} >
        <Navbarsalaamstree></Navbarsalaamstree>

        <div className='slider-container' style={{ height: "20px" }}></div>
        <div style={{ marginBottom: "30px" }}>
          <img src={cover} width="100%"></img>
        </div>

        

        <div className='details-container'>
          <span style={{color:green,fontWeight:"bold"}}>{location.state.category}</span>
          <span className='title' style={{textDecoration:"none",color:pink}}>{location.state.item.name}</span>
          <div style={{width:"100%",height:"1px",backgroundColor:'#ED9DB3',marginBottom:"10px"}}></div>
          <div className='details-image-container'>
            <img src={location.state.item.url}  height="100%" ></img>
          </div>

          <div className='p-container'>
            <span style={{whiteSpace:"pre-line",lineHeight:"5px"}}>
              {location.state.item.des}
            </span>
          </div>

        </div>

        <Salaamstree></Salaamstree>

        <Footer></Footer>




      </div>
    );
  
}

